import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { DatePicker, Button, Select, Row, Card } from 'antd';
import { DownloadOutlined, ExportOutlined, ReloadOutlined } from '@ant-design/icons';
import PageTitle from '@/components/PageTitle';
import TableActionBar from '@/components/TableActionBar';
import _, { } from 'lodash';
import qs from 'qs';
import { Form } from '@ant-design/compatible';
import { checkPermission } from '@/utils/permission';
import { cleanObject, customerServiceStatus } from '@/utils/helpers';
import HtmlParser from 'react-html-parser';
import BaseSelect from '@/components/Elements/BaseSelect';
import moment from 'moment';
import { getListServices, getSpecificService, getStatistical, exportExcel } from '@/redux/actions/customerServicesActions';
import StatisticNumber from '@/components/StatisticNumber';
import DynamicTable from '@/components/DynamicTable';
import FilterableMultiTreeSelect from '@/components/FilterableMultiTreeSelect';
import FilterableMultiSelect from '@/components/FilterableMultiSelect';
import { NotificationManager } from 'react-notifications';
import PhoneNumberList from '@/components/PhoneNumberList';
import html2canvas from 'html2canvas';
import CustomerInfoColumn from '@/components/customers/CustomerInfoColumn';
import MedicalStaffBlock from '@/components/MedicalStaffBlock';
import { getCustomerServiceDoctorRoleGroups } from '@/components/customer-services/customerServiceDoctorRoleHelpers';
import { fetchFilters } from '@/redux/actions/filterActions';
import ServiceInfoCell from '@/components/ServiceInfoCell';
import RevenueSummaryCell from '@/components/RevenueSummaryCell';
import ServicePriceCell from '@/components/ServicePriceCell';
import CreatedAtCell from '@/components/CreatedAtCell';
import CustomerServicesDetail from '@/components/customer-services/CustomerServicesDetail';
import CustomerServiceForm from '@/components/customer-services/CustomerServiceForm';
import { recalculateCommission } from '@/redux/actions/commissionActions';

const { RangePicker } = DatePicker;
const routes = [
    {
        path: '/',
        breadcrumbName: 'Trang chủ',
    },
    {
        path: '/customer-services',
        breadcrumbName: 'Dịch vụ',
    },
]

const { Option } = Select;

class CustomerServiceList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            selectedRowKeys: [],
            isLoadingExport: false,
            loadingCapture: false,
            isOpenDetail: false,
            editServiceId: null,
            currentService: null,
        }
        this.tableRef = createRef();
    }

    componentDidMount() {
        var query = qs.parse(this.props.location.search.slice(1));
        this.loadData(query);
        this.props.getStatistical(query);
        this.props.fetchFilters();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.location.search !== this.props.location.search.slice()) {
            var query = qs.parse(nextProps.location.search.slice(1));
            this.loadData(query);
            this.props.getStatistical(query);
        }
    }

    onChangeFilter(name, value) {
        var query = qs.parse(this.props.location.search.slice(1));
        query = {
            ...query,
            [name]: value
        }
        if (name === 'created_at') {
            if (value && value.length > 0) {
                query.created_date_start = moment(value[0]).format('YYYY-MM-DD');
                query.created_date_end = moment(value[1]).format('YYYY-MM-DD');
            } else {
                delete query.created_date_start;
                delete query.created_date_end;
            }
        }

        if (name === 'selected_at') {
            if (value && value.length > 0) {
                query.selected_date_start = moment(value[0]).format('YYYY-MM-DD');
                query.selected_date_end = moment(value[1]).format('YYYY-MM-DD');
            } else {
                delete query.selected_date_start;
                delete query.selected_date_end;
            }
        }

        if (name === 'staff_change_at') {
            if (value && value.length > 0) {
                query.staff_change_date_start = moment(value[0]).format('YYYY-MM-DD');
                query.staff_change_date_end = moment(value[1]).format('YYYY-MM-DD');
            } else {
                delete query.staff_change_date_start;
                delete query.staff_change_date_end;
            }
        }

        if (name === 'staff_effective_from') {
            if (value && value.length > 0) {
                query.staff_effective_from_start = moment(value[0]).format('YYYY-MM-DD');
                query.staff_effective_from_end = moment(value[1]).format('YYYY-MM-DD');
            } else {
                delete query.staff_effective_from_start;
                delete query.staff_effective_from_end;
            }
        }

        if (name === 'staff_effective_to') {
            if (value && value.length > 0) {
                query.staff_effective_to_start = moment(value[0]).format('YYYY-MM-DD');
                query.staff_effective_to_end = moment(value[1]).format('YYYY-MM-DD');
            } else {
                delete query.staff_effective_to_start;
                delete query.staff_effective_to_end;
            }
        }

        delete query.created_at;
        delete query.selected_at;
        delete query.staff_change_at;
        delete query.staff_effective_from;
        delete query.staff_effective_to;
        query = cleanObject(query);
        //console.log("query: ", query)
        this.props.history.push({
            pathname: this.props.location.pathname,
            search: qs.stringify(query)
        });
    }

    onChangeTable(pagination, sorter) {
        var query = qs.parse(this.props.location.search.slice(1));
        if (!_.isEmpty(pagination)) {
            query = {
                ...query,
                page: pagination.current,
                per_page: pagination.pageSize,
            }
        }
        if (!_.isEmpty(sorter)) {
            if (sorter.order) {
                query = {
                    ...query,
                    sort_field: sorter.field,
                    sort_type: sorter.order === 'ascend' ? 'ASC' : 'DESC'
                }
            } else {
                delete query.sort_field;
                delete query.sort_type;
            }
        }

        this.props.history.push({
            pathname: this.props.location.pathname,
            search: qs.stringify(query),
        });
    }

    loadData(query) {
        this.setState({ isLoading: true });
        const request = this.props.getListServices(query);
        request.finally(() => this.setState({ isLoading: false }));
        this.props.getStatistical(query);
        return request;
    }

    openDetail = async (serviceId) => {
        const service = await this.props.getSpecificService(serviceId);
        this.setState({ currentService: service || null, isOpenDetail: true });
    };

    closeDetail = () => this.setState({ isOpenDetail: false, currentService: null });

    openEditFromDetail = () => this.setState((state) => ({
        editServiceId: Number(state.currentService?.id) || null,
    }));

    closeForm = () => this.setState({ editServiceId: null });

    reloadAfterEdit = async (serviceId) => {
        const query = qs.parse(this.props.location.search.slice(1));
        await this.loadData(query);
        if (
            this.state.isOpenDetail &&
            Number(this.state.currentService?.id) === Number(serviceId)
        ) {
            const service = await this.props.getSpecificService(serviceId);
            this.setState({ currentService: service || null });
        }
    };

    recalculateFromDetail = async (serviceId) => {
        const result = await this.props.recalculateCommission(serviceId);
        const query = qs.parse(this.props.location.search.slice(1));
        await this.loadData(query);
        if (this.state.isOpenDetail && Number(this.state.currentService?.id) === Number(serviceId)) {
            const service = await this.props.getSpecificService(serviceId);
            this.setState({ currentService: service || null });
        }
        return result;
    };

    onExport() {
        var query = qs.parse(this.props.location.search.slice(1));
        this.setState({ isLoadingExport: true });
        this.props.exportExcel(query).catch(err => {
            this.setState({ isLoadingExport: false });
        });
        this.setState({ isLoadingExport: false });
        NotificationManager.success("Quá trình xuất file đang được thực hiện. Vui lòng kiểm tra email của bạn sau ít phút.", "Thông báo");
    }

    handleCaptureClick = async () => {
        this.setState({ loadingCapture: true });

        const table = this.tableRef.current;
        if (!table) return;

        // Tạo một bảng tạm thời với kích thước lớn
        const clonedTable = table.cloneNode(true);
        clonedTable.style.width = 'max-content';
        clonedTable.style.height = 'max-content';

        // Thêm bảng tạm thời vào body để tránh các ràng buộc CSS
        document.body.appendChild(clonedTable);

        // Chụp ảnh của bảng tạm thời
        await html2canvas(clonedTable).then(canvas => {
            // Chuyển canvas thành hình ảnh và tải xuống
            const imgData = canvas.toDataURL('image/jpg');
            const link = document.createElement('a');
            const d = new Date();
            const f = (n) => (`0${n}`).slice(-2);
            link.href = imgData;
            link.download = `dich-vu-${[f(d.getDate()), f(d.getMonth() + 1), d.getFullYear(), f(d.getHours()), f(d.getMinutes())].join('-')}.jpg`;
            link.click();

            // Loại bỏ bảng tạm thời sau khi đã chụp ảnh
            document.body.removeChild(clonedTable);
        });
        this.setState({ loadingCapture: false });
    };

    render() {
        var { services, pagination, sales, users, filterData, statistical, doctors, staffRoles, staffComponents, staffChangeReasons } = this.props;
        var { isLoading, selectedRowKeys, isLoadingExport, loadingCapture, isOpenDetail, editServiceId, currentService } = this.state;
        const hasSelected = selectedRowKeys.length > 0;
        const allowDetail = checkPermission('customer_services', 'detail');
        const allowUpdate = checkPermission('customer_services', 'update');
        const allowCommissionRecalculate = checkPermission('commission_result', 'calculate');

        var query = qs.parse(this.props.location.search.slice(1));

        const customer_source_active_list = filterData?.sources || [];
        const branchActiveList = filterData?.branches || [];
        const service_active_list = filterData?.services || [];

        const columns = [
            {
                title: 'Khách hàng',
                key: 'customer',
                width: 300,
                render: (_, record) => {

                    const customerRecord = record?.customer;

                    const customer = {
                        id: customerRecord?.id,
                        code: customerRecord?.code,
                        full_name: customerRecord?.full_name,
                        branch_name: customerRecord?.branch?.name,
                        conditions: customerRecord?.conditions,
                        customer_source: customerRecord?.customer_source?.name,
                        customer_status: customerRecord?.customer_status?.name,
                        customer_status_color: customerRecord?.customer_status?.text_color,
                        medical_book_number: customerRecord?.medical_book_number
                    }
                    return (
                        <CustomerInfoColumn
                            record={customer}
                            nameField="full_name"          // field tuỳ module
                            idField="id"
                            codeField="code"
                            branchField="branch_name"
                            sourceField="customer_source"
                            statusField="customer_status"
                            statusColorField="customer_status_color"
                        />
                    )
                }
            },
            {
                title: 'Điện thoại',
                dataIndex: 'phone',
                width: '120px',
                key: 'phone',
                render: (text, record) => {
                    return (
                        <PhoneNumberList phones={record?.customer?.phones} />
                    )
                }
            },
            {
                title: 'Tài chính',
                key: 'financial',
                width: 200,
                align: 'right',
                render: (_, record) => (
                    <RevenueSummaryCell
                        financialOverview={record?.customer?.financial_overview}
                        align="right"
                    />
                )
            },
            {
                title: 'Dịch vụ',
                key: 'service_info',
                width: 260,
                render: (_, record) => (
                    <ServiceInfoCell
                        service={record.service}
                        status={record.status}
                        type={record.type}
                        selectedAt={record.selected_at}
                        onNameClick={allowDetail ? () => this.openDetail(record.id) : null}
                        nameTooltip="Xem chi tiết dịch vụ"
                    />
                )
            },
            {
                title: 'Giá & số lượng',
                key: 'service_price',
                width: 200,
                sorter: true,
                align: 'right',
                render: (_, record) => (
                    <ServicePriceCell
                        regularPrice={record.regular_price}
                        salePrice={record.sale_price}
                        quantity={record.quantity}
                        amount={record.amount}
                    />
                )
            },
            {
                title: 'Ghi chú',
                dataIndex: 'note',
                key: 'note',
                width: '200px',
                render: (text, record) => {
                    return (
                        <>{HtmlParser(text)}</>
                    )
                }
            },
            {
                title: 'Nhân viên sales',
                dataIndex: 'sales',
                key: 'sales',
                width: 250,
                render: (_, record) => {
                    const list = record.sales || [];
                    if (list.length === 0) return null;

                    return (
                        <div style={{ lineHeight: 1.3 }}>
                            {list.map(item => (
                                <div key={item.id}>
                                    <span style={{ color: '#999' }}>{item?.sales?.user_role?.name}: </span>
                                    <span style={{ fontWeight: 600 }}>{item?.sales?.full_name}</span>
                                </div>
                            ))}
                        </div>
                    );
                },
            },
            {
                title: 'Nhân sự phụ trách',
                key: 'medical_staff',
                width: 260,
                render: (_, record) => (
                    <MedicalStaffBlock
                        doctorRoleGroups={getCustomerServiceDoctorRoleGroups(record)}
                        assistants={record.assistants}
                    />
                )
            },
            {
                title: 'Ngày tạo',
                dataIndex: 'created_at',
                key: 'created_at',
                width: '220px',
                render: (text, record) => (
                    <CreatedAtCell
                        createdAt={text}
                        user={record?.created_user}
                    />
                )
            }
        ];

        return (
            <div>
                <PageTitle routes={routes} title="Dịch vụ" />
                <div>
                    <TableActionBar
                        isShowAddButton={false}
                        isShowDeleteButton={false}
                        showFilter={true}
                        onSearch={(value) => this.onChangeFilter('keyword', value)}
                        defaultKeyword={query.keyword}
                        filterColSpan={6}
                        activeFilter={
                            query.created_date_start ||
                            query.created_date_end ||
                            query.selected_date_start ||
                            query.selected_date_end ||
                            query.type ||
                            query.service_id ||
                            query.branch_id ||
                            query.customer_source_id ||
                            query.status ||
                            query.examination_doctor_id || query.treatment_doctor_id ||
                            query.implant_doctor_id || query.prosthetic_doctor_id ||
                            query.apprentice_doctor_id || query.sales_id || query.assistant_id ||
                            query.current_staff_id || query.ever_staff_id || query.former_staff_id ||
                            query.incoming_staff_id || query.outgoing_staff_id || query.has_staff_change ||
                            query.staff_role_key || query.staff_component_key || query.staff_change_reason ||
                            query.staff_change_type || query.staff_change_is_failure ||
                            query.staff_change_date_start || query.staff_change_date_end
                            || query.staff_effective_from_start || query.staff_effective_from_end
                            || query.staff_effective_to_start || query.staff_effective_to_end
                        }
                        placeholderSearch="Mã, tên, 3 số cuối sđt của khách hàng"
                        filters={
                            [
                                <BaseSelect
                                    options={doctors || []}
                                    optionValue="user_id"
                                    optionLabel="display_name"
                                    showSearch
                                    placeholder="Bác sĩ khám"
                                    className="w-100"
                                    onChange={(value) => this.onChangeFilter('examination_doctor_id', value)}
                                    defaultValue={query.examination_doctor_id ? parseInt(query.examination_doctor_id, 10) : null}
                                />,
                                <BaseSelect
                                    options={doctors || []}
                                    optionValue="user_id"
                                    optionLabel="display_name"
                                    showSearch
                                    placeholder="Bác sĩ điều trị"
                                    className="w-100"
                                    onChange={(value) => this.onChangeFilter('treatment_doctor_id', value)}
                                    defaultValue={query.treatment_doctor_id ? parseInt(query.treatment_doctor_id, 10) : null}
                                />,
                                <BaseSelect
                                    options={doctors || []} optionValue="user_id" optionLabel="display_name" showSearch
                                    placeholder="Bác sĩ cắm trụ" className="w-100"
                                    onChange={(value) => this.onChangeFilter('implant_doctor_id', value)}
                                    defaultValue={query.implant_doctor_id ? parseInt(query.implant_doctor_id, 10) : null}
                                />,
                                <BaseSelect
                                    options={doctors || []} optionValue="user_id" optionLabel="display_name" showSearch
                                    placeholder="Bác sĩ phục hình" className="w-100"
                                    onChange={(value) => this.onChangeFilter('prosthetic_doctor_id', value)}
                                    defaultValue={query.prosthetic_doctor_id ? parseInt(query.prosthetic_doctor_id, 10) : null}
                                />,
                                <BaseSelect
                                    options={doctors || []} optionValue="user_id" optionLabel="display_name" showSearch
                                    placeholder="Bác sĩ học việc" className="w-100"
                                    onChange={(value) => this.onChangeFilter('apprentice_doctor_id', value)}
                                    defaultValue={query.apprentice_doctor_id ? parseInt(query.apprentice_doctor_id, 10) : null}
                                />,
                                <BaseSelect
                                    options={sales || []} optionValue="user_id" optionLabel="display_name" showSearch
                                    placeholder="Sales" className="w-100"
                                    onChange={(value) => this.onChangeFilter('sales_id', value)}
                                    defaultValue={query.sales_id ? parseInt(query.sales_id, 10) : null}
                                />,
                                <BaseSelect
                                    options={users || []} optionValue="user_id" optionLabel="display_name" showSearch
                                    placeholder="Phụ tá" className="w-100"
                                    onChange={(value) => this.onChangeFilter('assistant_id', value)}
                                    defaultValue={query.assistant_id ? parseInt(query.assistant_id, 10) : null}
                                />,
                                <BaseSelect
                                    options={users || []}
                                    optionValue="user_id"
                                    optionLabel="display_name"
                                    showSearch
                                    placeholder="Nhân sự đang phụ trách"
                                    className="w-100"
                                    onChange={(value) => this.onChangeFilter('current_staff_id', value)}
                                    defaultValue={query.current_staff_id ? parseInt(query.current_staff_id, 10) : null}
                                />,
                                <BaseSelect
                                    options={users || []}
                                    optionValue="user_id"
                                    optionLabel="display_name"
                                    showSearch
                                    placeholder="Đã từng phụ trách"
                                    className="w-100"
                                    onChange={(value) => this.onChangeFilter('ever_staff_id', value)}
                                    defaultValue={query.ever_staff_id ? parseInt(query.ever_staff_id, 10) : null}
                                />,
                                <BaseSelect
                                    options={users || []}
                                    optionValue="user_id"
                                    optionLabel="display_name"
                                    showSearch
                                    placeholder="Nhân sự cũ"
                                    className="w-100"
                                    onChange={(value) => this.onChangeFilter('former_staff_id', value)}
                                    defaultValue={query.former_staff_id ? parseInt(query.former_staff_id, 10) : null}
                                />,
                                <BaseSelect
                                    options={users || []}
                                    optionValue="user_id"
                                    optionLabel="display_name"
                                    showSearch
                                    placeholder="Người nhận bàn giao"
                                    className="w-100"
                                    onChange={(value) => this.onChangeFilter('incoming_staff_id', value)}
                                    defaultValue={query.incoming_staff_id ? parseInt(query.incoming_staff_id, 10) : null}
                                />,
                                <BaseSelect
                                    options={users || []}
                                    optionValue="user_id"
                                    optionLabel="display_name"
                                    showSearch
                                    placeholder="Người bàn giao"
                                    className="w-100"
                                    onChange={(value) => this.onChangeFilter('outgoing_staff_id', value)}
                                    defaultValue={query.outgoing_staff_id ? parseInt(query.outgoing_staff_id, 10) : null}
                                />,
                                <Select allowClear className="w-100" placeholder="Có thay đổi phân công" value={query.has_staff_change} onChange={(value) => this.onChangeFilter('has_staff_change', value)}>
                                    <Option value="1">Có</Option><Option value="0">Không</Option>
                                </Select>,
                                <Select allowClear className="w-100" placeholder="Vai trò nhân sự" value={query.staff_role_key} onChange={(value) => this.onChangeFilter('staff_role_key', value)} options={(staffRoles || []).map(row => ({ value: row.role_key, label: row.label }))} />,
                                <Select allowClear className="w-100" placeholder="Thành phần công việc" value={query.staff_component_key} onChange={(value) => this.onChangeFilter('staff_component_key', value)} options={(staffComponents || []).map(row => ({ value: row.component_key, label: row.label }))} />,
                                <Select allowClear className="w-100" placeholder="Lý do chuyển giao" value={query.staff_change_reason} onChange={(value) => this.onChangeFilter('staff_change_reason', value)} options={(staffChangeReasons || []).map(row => ({ value: row.reason_code, label: row.label }))} />,
                                <Select allowClear className="w-100" placeholder="Loại thay đổi" value={query.staff_change_type} onChange={(value) => this.onChangeFilter('staff_change_type', value)}>
                                    <Option value="ASSIGN">Phân công</Option><Option value="HANDOVER">Bàn giao</Option><Option value="END">Kết thúc</Option><Option value="ROLE_CHANGE">Đổi vai trò</Option><Option value="CORRECTION">Điều chỉnh lịch sử</Option>
                                </Select>,
                                <Select allowClear className="w-100" placeholder="Phân loại ca fail" value={query.staff_change_is_failure} onChange={(value) => this.onChangeFilter('staff_change_is_failure', value)}>
                                    <Option value="1">Là ca fail</Option><Option value="0">Không phải ca fail</Option>
                                </Select>,
                                <RangePicker
                                    format="DD/MM/YYYY"
                                    placeholder={['Ngày chuyển giao', 'đến ngày']}
                                    className="w-100"
                                    onChange={(value) => this.onChangeFilter('staff_change_at', value)}
                                    defaultValue={[query.staff_change_date_start ? moment(query.staff_change_date_start, 'YYYY-MM-DD') : null, query.staff_change_date_end ? moment(query.staff_change_date_end, 'YYYY-MM-DD') : null]}
                                />,
                                <RangePicker
                                    format="DD/MM/YYYY"
                                    placeholder={['Bắt đầu phụ trách', 'đến ngày']}
                                    className="w-100"
                                    onChange={(value) => this.onChangeFilter('staff_effective_from', value)}
                                    defaultValue={[query.staff_effective_from_start ? moment(query.staff_effective_from_start, 'YYYY-MM-DD') : null, query.staff_effective_from_end ? moment(query.staff_effective_from_end, 'YYYY-MM-DD') : null]}
                                />,
                                <RangePicker
                                    format="DD/MM/YYYY"
                                    placeholder={['Kết thúc phụ trách', 'đến ngày']}
                                    className="w-100"
                                    onChange={(value) => this.onChangeFilter('staff_effective_to', value)}
                                    defaultValue={[query.staff_effective_to_start ? moment(query.staff_effective_to_start, 'YYYY-MM-DD') : null, query.staff_effective_to_end ? moment(query.staff_effective_to_end, 'YYYY-MM-DD') : null]}
                                />,
                                <FilterableMultiSelect
                                    options={branchActiveList || []}
                                    placeholder="Chọn cơ sở"
                                    parameterName='branch_id'
                                    optionValue="id"
                                    optionLabel="name"
                                />,
                                <RangePicker
                                    format="DD/MM/YYYY"
                                    placeholder={['Ngày tạo', 'đến ngày']}
                                    className="w-100"
                                    onChange={(value) => this.onChangeFilter('created_at', value)}
                                    defaultValue={[query.created_date_start ? moment(query.created_date_start, 'YYYY-MM-DD') : null, query.created_date_end ? moment(query.created_date_end, 'YYYY-MM-DD') : null]}
                                />,
                                <FilterableMultiTreeSelect
                                    options={service_active_list || []}
                                    placeholder="Dịch vụ"
                                    parameterName='service_id'
                                />,
                                <FilterableMultiSelect
                                    options={customerServiceStatus || []}
                                    placeholder="Trạng thái"
                                    parameterName='status'
                                    optionValue="value"
                                    optionLabel="label"
                                />,
                                <FilterableMultiSelect
                                    options={customer_source_active_list || []}
                                    placeholder="Nguồn khách hàng"
                                    parameterName='customer_source_id'
                                    optionValue="id"
                                    optionLabel="name"
                                />
                            ]
                        }
                    >
                        <RangePicker
                            format="DD/MM/YYYY"
                            placeholder={['Ngày chốt', 'đến ngày']}
                            className="table-button"
                            style={{ width: '250px' }}
                            onChange={(value) => this.onChangeFilter('selected_at', value)}
                            defaultValue={[query.selected_date_start ? moment(query.selected_date_start, 'YYYY-MM-DD') : null, query.selected_date_end ? moment(query.selected_date_end, 'YYYY-MM-DD') : null]}
                        />
                        {
                            checkPermission('customer_services', 'export') ? (
                                <Button className="table-button" loading={isLoadingExport} type='default' onClick={() => this.onExport()} icon={<ExportOutlined />}>Export</Button>
                            ) : null
                        }
                        <Button className="table-button" type='primary' icon={<DownloadOutlined />} loading={loadingCapture} onClick={() => this.handleCaptureClick()}>Chụp màn hình</Button>
                        <Button className="table-button" icon={<ReloadOutlined />} loading={isLoading} onClick={() => this.loadData(query)}>Refresh</Button>
                        {
                            hasSelected ? <span>Đang chọn {selectedRowKeys.length} bản ghi</span> : ''
                        }
                    </TableActionBar>
                </div>
                <Row gutter={16} className="mb-2" justify="space-between" style={{ margin: 0 }}>
                    <Card className="customer-services-list-statistic">
                        <StatisticNumber
                            title="Khách chốt"
                            value={statistical?.total_customer || 0}
                            precision={0}
                        />
                    </Card>
                    <Card className="customer-services-list-statistic">
                        <StatisticNumber
                            title="Dịch vụ chốt"
                            value={statistical?.total_completed_services || 0}
                            precision={0}
                        />
                    </Card>
                    <Card className="customer-services-list-statistic">
                        <StatisticNumber
                            title="Giá gốc"
                            value={statistical?.total_regular_price || 0}
                            precision={0}
                            unit="đ"
                        />
                    </Card>
                    <Card className="customer-services-list-statistic">
                        <StatisticNumber
                            title="Giá bán"
                            value={statistical?.total_sale_price ?? 0}
                            precision={0}
                            unit="đ"
                        />
                    </Card>
                    <Card className="customer-services-list-statistic">
                        <StatisticNumber
                            title="Mức giảm giá"
                            value={statistical?.discount_rate || 0}
                            precision={0}
                            unit="đ"
                        />
                    </Card>
                    <Card className="customer-services-list-statistic">
                        <StatisticNumber
                            title="Thành tiền"
                            value={statistical?.total_amount || 0}
                            precision={0}
                            unit="đ"
                        />
                    </Card>
                </Row>
                <div className='has-custom-column-table-btn' ref={this.tableRef}>
                    <DynamicTable
                        rowKey="id"
                        ref={this.tableRef}
                        dataSource={services || []}
                        columns={columns}
                        isLoading={isLoading}
                        pagination={pagination}
                        moduleKey="customer_services"
                        rowSelection={false}
                        onChangeTable={(pagination, sorter) => this.onChangeTable(pagination, sorter)}
                    />
                </div>
                <CustomerServicesDetail
                    visible={isOpenDetail}
                    currentItem={currentService}
                    onCancel={this.closeDetail}
                    allowEdit={allowUpdate}
                    onEdit={this.openEditFromDetail}
                    allowCommissionRecalculate={allowCommissionRecalculate}
                    onCommissionRecalculate={this.recalculateFromDetail}
                    zIndex={editServiceId ? 999 : undefined}
                />
                <CustomerServiceForm
                    visible={!!editServiceId}
                    customerId={Number(currentService?.customer_id || currentService?.customer?.id)}
                    currentData={null}
                    customerServiceId={editServiceId}
                    reloadData={this.reloadAfterEdit}
                    onCancel={this.closeForm}
                />
            </div>
        )
    }
}

function mapStateToProps(state) {

    return {
        services: state.customerServicesReducer.services,
        pagination: state.customerServicesReducer.pagination,
        statistical: state.customerServicesReducer.statistical,
        doctors: state.config.doctors,
        sales: state.config.sales,
        users: state.config.users,
        staffRoles: state.config.customer_service_staff_roles,
        staffComponents: state.config.customer_service_staff_components,
        staffChangeReasons: state.config.customer_service_staff_change_reasons,
        filterData: state.filterReducer.list
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getListServices: (filter) => dispatch(getListServices(filter)),
        getSpecificService: (id) => dispatch(getSpecificService(id)),
        getStatistical: filter => dispatch(getStatistical(filter)),
        exportExcel: (filter) => dispatch(exportExcel(filter)),
        fetchFilters: () => dispatch(fetchFilters()),
        recalculateCommission: (id) => dispatch(recalculateCommission(id)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create({ name: 'CustomerServiceList' })(CustomerServiceList));

